import React from "react";
import AdminTeamConsumerDocuments from "./AdminTeamConsumerDocuments";

export default function AdminTeamConsumerCertificateUploads() {
  return <AdminTeamConsumerDocuments kind="CERTIFICATE" />;
}
